// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2FlG2","list":"styles_list__1szhx"};